const playback = {
  path: 'playback',
  component: resolve => require(['../../../../../pages/user/course/calendar/playback'], resolve)
}

export default playback



// WEBPACK FOOTER //
// ./src/router/user/course/calendar/playback/index.js